import { Component } from "react";

export default class CookiebotInit extends Component {
  componentDidMount() {
    this.loadCookiebotScript();
  }

  loadCookiebotScript = () => {
    const cbid = process.env.REACT_APP_CBID;
    if (!cbid) {
      console.warn("REACT_APP_CBID not configured. Cookiebot will not load.");
      return;
    }

    // avoid double-loading
    if (document.getElementById("Cookiebot")) {
      console.warn("Cookiebot script already loaded.");
      return;
    }

    const script = document.createElement("script");
    script.id = "Cookiebot";

    // Use the correct uc.js URL as per official Cookiebot documentation
    script.src = "https://consent.cookiebot.com/uc.js";

    // Set data attributes for proper configuration
    script.setAttribute("data-cbid", cbid);
    script.setAttribute("data-blockingmode", "auto");
    script.setAttribute("type", "text/javascript");

    script.async = true;
    script.onload = () => {
      // Wait a bit for Cookiebot to be fully initialized
      setTimeout(() => {
        if (!window.Cookiebot) {
          console.error(
            "Cookiebot script loaded but Cookiebot object is not available.",
          );
        }
      }, 100);
    };

    script.onerror = () => {
      console.error("Failed to load Cookiebot script");
    };

    document.head.appendChild(script);
  };

  render() {
    return null;
  }
}
